// extracted by mini-css-extract-plugin
export default {"nav":"nav___NGmcJ","subPathText":"subPathText___EyRbu","active":"active___q_t6f","icon":"icon____hwOb"};